<template>
  <Modal
    :show="true"
    title=" "
    size="xs"
    :dialogStyle="{ maxWidth: '360px', minHeight: '180px' }"
    :closeOnBackdrop="false"
    :blur-backdrop="false"
    :backdropOpacity="0.3"
    :zIndex="10070"
    @close="closeModal"
  >
    <template #header>
      <div class="delete-header">
        <Icon icon="mdi:delete-outline" width="28" height="28" class="delete-header-icon" />
        <h6 class="delete-header-title">Delete Phone Number</h6>
      </div>
    </template>
    <template #body>
      <div class="delete-phone-body">
        <p class="delete-phone-subtitle">Are you sure you want to delete this Phone Number?</p>
      </div>
    </template>

    <template #footer>
      <Button variant="outline" size="sm" @click="closeModal">Cancel</Button>
      <Button
        variant="danger"
        size="sm"
        :loading="isDeleting"
        :disabled="isDeleting"
        @click="deleteRecord"
      >
        Delete
      </Button>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { Icon } from "@iconify/vue";
import { Button, Modal } from "@/components/ui";

const props = defineProps({
  deleteFunction: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(["close", "refresh"]);

const isDeleting = ref(false);

function closeModal() {
  emit("close");
}

async function deleteRecord() {
  if (isDeleting.value) return;
  isDeleting.value = true;
  try {
    const res = await props.deleteFunction();
    if (res != null) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      closeModal();
      emit("refresh");
    }
  } catch (error) {
    console.error("Error during deletion:", error);
  } finally {
    isDeleting.value = false;
  }
}
</script>

<style scoped>
.delete-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.delete-header-icon {
  color: #ef4444;
  flex-shrink: 0;
}

.delete-header-title {
  font-weight: 600;
  font-size: 15px;
  color: #111827;
  margin: 0;
  line-height: 1.4;
}

.delete-phone-body {
  padding: 16px 20px 20px;
}

.delete-phone-subtitle {
  font-size: 0.8125rem;
  font-weight: 400;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
  text-align: left;
}
</style>
